import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import {
  CreditAllocationStatus,
  Receivable_Transaction_Type,
} from "gen/txn/models_pb"
import { FilterT } from "shared-ts/hooks/useFilter/types/filter.types"
import { FullInterval } from "shared-ts/libs/dates/interval"
import { useDateFilter } from "shared-web/hooks/useDateFilter"

import { useCustomerFilter } from "hooks/filters/useCustomerFilter"

import { useCreditsTableStatusFilter } from "./useCreditsStatusFilter"
import { useCreditTransactionTypeFilter } from "./useCreditTransactionTypeFilter"

interface UseCreditsTableFiltersRes {
  filters: FilterT[]
  selectedCustomerIds: PBUUID[]
  selectedStatuses: CreditAllocationStatus[]
  selectedDateRange: FullInterval | null
  selectedTransactionTypes: Receivable_Transaction_Type[]
}

export function useCreditsTableFilters(): UseCreditsTableFiltersRes {
  const customerFilter = useCustomerFilter()
  const dateFilter = useDateFilter({ persistInUrl: false })
  const statusFilter = useCreditsTableStatusFilter()
  const transactionTypeFilter = useCreditTransactionTypeFilter()

  return {
    filters: [
      customerFilter.filter,
      dateFilter.filter,
      statusFilter.filter,
      transactionTypeFilter.filter,
    ],
    selectedStatuses: statusFilter.selected,
    selectedTransactionTypes: transactionTypeFilter.selected,
    selectedCustomerIds: customerFilter.selectedCustomerIds,
    selectedDateRange: dateFilter.selectedDateRange,
  }
}
